import React from 'react';
import './Pokerwatch_new.css';
import Dialog from 'material-ui/Dialog';
class CustomisedDialog extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {

        }
    }

    render() {
        const {isDialogOpen,newButton,isButtonsShow,title,width,fontSize,height,dataType,customStyle,cancelDialog,padding, actionPerform,errorMessage,isError,fontWeight,createButtonLable,createButtonStyleName,titleAlign} = this.props;
        if(!isDialogOpen){
            return ''
        }
        return<Dialog title={title}
        titleStyle={{
          backgroundColor: "white", fontSize: fontSize, color: "black", width: width, textAlign: titleAlign?titleAlign:'left', font: "Open Sans", fontWeight: fontWeight||'bold', paddingBottom: '0px',
           paddingTop: '30px',paddingLeft:'19px',borderRadius:'4px 4px  0px 0px'
        }}
        autoScrollBodyContent={true}
        modal={false} open={isDialogOpen}
        bodyStyle={{ backgroundColor: "white", width:  width, height:height,padding:padding,borderRadius:'0px 0px  4px 4px' }}
        contentStyle={{ backgroundColor: "white" }}
        style={customStyle}
        onRequestClose={e => cancelDialog(e,  {dataType})}
      >
        {this.props.children}
         <span style={{color:'red'}}>{errorMessage} </span>
         {isButtonsShow && <div className="poker-watch-create-team-buttons-div">
          <button className="poker-watch-cancel-team-button"data-e2e="team-cancel" onClick={e => cancelDialog(e, {dataType})} >Cancel</button>
          <button className={createButtonStyleName?createButtonStyleName:"poker-watch-create-team-button-not-active"} data-e2e="team-create" onClick={isError?'':actionPerform}>{createButtonLable?createButtonLable:'create'}</button>
      </div> }
        {newButton ? <button className={createButtonStyleName?createButtonStyleName:"poker-watch-new-button-not-active"} onClick={isError?'':actionPerform}>{createButtonLable?createButtonLable:'create'}</button>:''}

      </Dialog >
    }
}

export default CustomisedDialog;


/** WEBPACK FOOTER **
 ** ./src/components/PokerWatchNew/CustomisedDialog.js
 **/